import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../services/i18nService';

class PlayPauseButton extends React.Component {
    static propTypes = {
        action: PropTypes.string,
        canPreload: PropTypes.bool,
        fullyLoaded: PropTypes.bool,
        isLocked: PropTypes.bool,
        onClick: PropTypes.func,
        describedById: PropTypes.string,
    };

    render() {
        const { action, canPreload, fullyLoaded, isLocked, onClick, describedById } = this.props;

        const btnProps = {
            icon: 'fa fa-lock',
            className: ['playerButton'],
            disabled: onClick === undefined,
            title: t('multimedia.actionButton.locked'),
        };

        if (action === 'play' && canPreload && !fullyLoaded) {
            btnProps.icon = 'fa fa-refresh fa-spin';
            btnProps.title = t('multimedia.actionButton.loading');
        } else if (action === 'play') {
            btnProps.icon = 'fa fa-play';
            btnProps.title = t('multimedia.actionButton.play');
        } else if (action === 'pause') {
            btnProps.icon = 'fa fa-pause';
            btnProps.title = t('multimedia.actionButton.pause');
        }

        if (btnProps.disabled) {
            btnProps.className.push('disabled');
        }

        if (isLocked) {
            btnProps.className.push('locked');
        }

        return (
            <button
                className={btnProps.className.join(' ')}
                disabled={btnProps.disabled}
                onClick={onClick}
                aria-label={btnProps.title}
                aria-describedby={describedById}
            >
                <i className={btnProps.icon} />
            </button>
        );
    }
}

export default PlayPauseButton;
